import locale_de from '../translations/de.js';
import locale_dev_en from '../translations/en.dev.js';
import locale_en from '../translations/en.js';
import locale_es from '../translations/es.js';
import locale_fr from '../translations/fr.js';
import locale_ja from '../translations/ja.js';
import locale_ko from '../translations/ko.js';
import locale_pt from '../translations/pt.js';
import locale_ru from '../translations/ru.js';
import locale_zh from '../translations/zh.js';

export const defaultLocale = 'en';

export type Locales = { [key: string]: string };

const translations: { [key: string]: Locales } = {
  en: locale_en,
  ru: locale_ru,
  de: locale_de,
  ko: locale_ko,
  ja: locale_ja,
  zh: locale_zh,
  es: locale_es,
  pt: locale_pt,
  fr: locale_fr
};

export const getTranslationsData = (locale?: string): Locales => {
  const labels = !locale || !translations[locale] ? translations.en : translations[locale];
  return {
    ...translations[defaultLocale],
    ...locale_dev_en,
    ...labels
  };
};
